import {ElNotification} from 'element-plus';

const ElNotify = ElNotification;

export default ElNotify;